// Libs
import React from 'react';
import ExpandingTextArea from 'react-expanding-textarea';

// Services & Helpers
import API from 'API';
import TextHelpers from 'helpers/TextHelpers';

// Components
import Loader from 'components/common/Loader';

class EditSupplier extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            error: null,
            successMessage: null
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const { id } = this.props;
        this.setState({
            isLoading: true,
            error: null
        });
        try {
            let supplier;
            const categories = await API.call('supplier-category/list');
            if (parseInt(id)) {
                supplier = await API.call('supplier/get', {
                    id: (id || 0)
                });
            } else {
                supplier = {
                    supplierCategoryID: (categories.length > 0 ? categories[0].id : null)
                };
            }
            this.setState({
                isLoading: false,
                supplier,
                categories
            });
        } catch (error) {
            this.setState({
                isLoading: false,
                error: error || 'Failed to load supplier'
            });
        }
    }

    updateFields(values) {
        const supplier = { ...this.state.supplier };
        for (let fieldName in values) {
            const value = values[fieldName];
            supplier[fieldName] = value;
            if (fieldName == 'name' && !supplier.id) {
                supplier.slug = TextHelpers.getSlug(value);
            }
        }
        this.setState({ supplier });
    }

    async save() {
        const { supplier } = this.state;
        
        // Frontend validation matching backend rules
        if (!supplier.name || supplier.name.trim() === '') {
            this.setState({ 
                error: 'Name is required',
                successMessage: null 
            });
            return;
        }
        
        if (!supplier.supplierCategoryID) {
            this.setState({ 
                error: 'Supplier category is required',
                successMessage: null 
            });
            return;
        }
        
        this.setState({ 
            isLoading: true,
            error: null,
            successMessage: null
        });
        
        try {
            await API.call('supplier/save', supplier);
            this.setState({
                isLoading: false,
                successMessage: 'Supplier saved successfully!'
            });
            // Redirect after showing success message
            setTimeout(() => {
                this.props.history.replace('/admin/suppliers');
            }, 1500);
        } catch (error) {
            this.setState({
                isLoading: false,
                error: error || 'Failed to save supplier'
            });
        }
    }

    confirmDelete() {
        const confirm = window.confirm('Are you sure you want to delete this supplier?');
        if (confirm) {
            this.delete();
        }
    }

    async delete() {
        this.setState({ 
            isLoading: true,
            error: null,
            successMessage: null
        });
        
        try {
            await API.call('supplier/delete/' + this.state.supplier.id);
            this.setState({
                isLoading: false,
                successMessage: 'Supplier deleted successfully!'
            });
            // Redirect after showing success message
            setTimeout(() => {
                this.props.history.replace('/admin/suppliers');
            }, 1500);
        } catch (error) {
            this.setState({
                isLoading: false,
                error: error || 'Failed to delete supplier'
            });
        }
    }

    render() {
        return (
            <section>

                <h2>Supplier</h2>

                {this.renderInner()}

            </section>
        );
    }

    renderInner() {
        const {
            isLoading,
            supplier,
            categories,
            error,
            successMessage
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (

            <form onSubmit={e => {
                e.preventDefault();
                e.stopPropagation();
                this.save();
            }}>

                {error &&
                    <div className="alert alert-danger" role="alert">
                        <i className="fa-solid fa-exclamation-triangle"></i>{' '}
                        {error}
                    </div>
                }

                {successMessage &&
                    <div className="alert alert-success" role="alert">
                        <i className="fa-solid fa-check-circle"></i>{' '}
                        {successMessage}
                    </div>
                }

                <div className="form-group">
                    <label className="form-label">Name</label>
                    <input
                        type="text"
                        className="form-control"
                        value={supplier.name || ''}
                        onChange={e => this.updateFields({ name: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Slug</label>
                    <input
                        type="text"
                        className="form-control"
                        value={supplier.slug || ''}
                        onChange={e => this.updateFields({ slug: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Category</label>
                    <select
                        className="form-control"
                        value={supplier.supplierCategoryID || ''}
                        onChange={e => this.updateFields({ supplierCategoryID: e.target.value })}
                    >
                        {categories.map(category =>
                            <option key={category.id} value={category.id}>
                                {category.name}
                            </option>
                        )}
                    </select>
                </div>

                <div className="form-group">
                    <label className="form-label">Inventory Location</label>
                    <input
                        type="text"
                        className="form-control"
                        value={supplier.inventoryLocation || ''}
                        onChange={e => this.updateFields({ inventoryLocation: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Contact Details</label>
                    <ExpandingTextArea
                        className="form-control"
                        value={supplier.contactDetails || ''}
                        onChange={e => this.updateFields({ contactDetails: e.target.value })}
                    />
                </div>

                <div className="form-group">
                    <label className="form-label">Supplier Information</label>
                    <ExpandingTextArea
                        className="form-control"
                        value={supplier.information || ''}
                        onChange={e => this.updateFields({ information: e.target.value })}
                    />
                </div>

                <div className="control-panel">

                    {!!supplier.id &&
                        <button type="button" className="btn btn-secondary" onClick={() => this.confirmDelete()}>
                            <span className="fa-solid fa-times" />{' '}
                            Delete
                        </button>
                    }

                    <button type="submit" className="btn btn-primary ms-auto">
                        <span className="fa-solid fa-check" />{' '}
                        Save
                    </button>

                </div>

            </form>

        );
    }
}

export default EditSupplier;
